//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitOptions.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.CurveOptions.js";
import "../GeometricUtilities/GeometricUtilities.LawBuilder.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[0,"AxialOffsetDirection",1,"Direction",0],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",0],[1,"CurveFitMethod",0,"GeometricUtilities.CurveFitOptions",0],[1,"CurvesToOffset",0,"Section",0],[1,"DraftAngle",0,"Expression",0],[1,"DraftHeight",0,"Expression",0],[0,"ExtendFactor",1,1],[0,"GroupObjects",1,0],[1,"InputCurvesOptions",0,"GeometricUtilities.CurveOptions",0],[1,"LawControl",0,"GeometricUtilities.LawBuilder",0],[0,"NumberOfCopies",1,0],[1,"Offset3dDistance",0,"Expression",0],[1,"OffsetDistance",0,"Expression",0],[0,"PointOnOffsetPlane",1,"Point",0],[0,"ReverseDirection",1,0],[0,"RoughOffset",1,0],[0,"Tolerance",1,0],[0,"TrimMethod",1,0],[0,"Type",1,0]],[[["offsetDirection","startPoint"],"ComputeOffsetDirection",{},0,0],[["seedEntity","seedPoint","offsetDirection","startPoint"],"ComputeOffsetDirection1",{},2,0]],[]];
SPLM.Features.OffsetCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.OffsetCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.OffsetCurveBuilder.TrimOption = Object.freeze({
    "None" : "None", "ExtendTangents" : "ExtendTangents", "Fillet" : "Fillet"});

SPLM.Features.OffsetCurveBuilder.Types = Object.freeze({
    "Distance" : "Distance", "Draft" : "Draft", "LawControl" : "LawControl", "Axial3d" : "Axial3d"});

export default SPLM;